<div class="h-full w-full flex flex-col justify-start items-center overflow-hidden">
  <div class="w-full h-full grid grid-cols-4 gap-2">

    <div class="col-span-1 h-full rounded-xl border border-gray-200 dark:border-white/10">
      <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
        <div class="px-2 py-4 drawer-header-primary overflow-hidden rounded-t-xl">
          <div class="flex space-x-3 h-full items-center">
            <div class="min-w-0 flex-1 px-2">
              <p class="text-md font-semibold text-primary">Build your monitoring brief</p>
              <p class="text-sm text-secondary">Complete the steps to launch your brief.</p>
            </div>
          </div>
        </div>
        <nav aria-label="Monitoring brief steps"
          class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-y-auto p-2">
          @for (step of steps(); track step.id; let i = $index) {
          <button type="button" (click)="goTo(i)" [attr.aria-current]="i === current() ? 'step' : null"
            class="mb-0.5 flex w-full items-center gap-3 px-2 py-2.5 text-left transition-colors hover:bg-muted"
            [class]="i === current() ? 'bg-brand-studio/10 rounded-md' : ''">
            <span
              class="grid size-8 flex-shrink-0 place-items-center rounded-full border font-heading text-sm font-bold transition-all"
              [class]="stepCircleClass(i)">
              @if (isDone(i)) {
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              } @else {
              {{ i + 1 }}
              }
            </span>
            <span>
              <span class="block font-heading text-base font-bold leading-tight"
                [class]="i === current() ? 'text-foreground' : 'text-foreground/80'">{{ step.label }}</span>
              <span class="block text-xs text-muted-foreground">{{ step.sub }}</span>
            </span>
          </button>
          }
        </nav>
      </div>
    </div>

    <div class="col-span-3 h-full overflow-hidden flex flex-col gap-y-2">
      <div class="w-full flex-1 overflow-hidden">
        <div #scrollArea class="h-full overflow-y-auto">
          <div class="mx-auto max-w-3xl px-6 sm:px-12">
            <div class="mb-7">
              <p class="text-xs font-bold uppercase tracking-wider text-brand-studio-dark dark:text-brand-studio">{{
                eyebrow() }}</p>
              <h2 class="mt-2.5 font-heading text-4xl font-bold leading-none tracking-tight">{{ step().title }}</h2>
              <p class="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground">{{ step().desc }}</p>
            </div>

            @switch (step().id) {
            @case ('product') { <cmb-product-select /> }
            @case ('define') { <cmb-monitoring-define /> }
            @case ('requirements') { <cmb-monitoring-requirements /> }
            @case ('window') { <cmb-monitoring-window /> }
            @case ('review') { <cmb-monitoring-review /> }
            @case ('creators') { <cmb-monitoring-creators /> }
            }
          </div>
        </div>
      </div>

      <div
        class="shrink-0 w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-white/10 flex flex-row items-center justify-between">
        <div class="flex-1 flex flex-row items-center justify-start gap-x-4">
          <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary shrink-0 inline-flex items-center gap-2"
            [disabled]="current() === 0" (click)="back()">
            Back
          </button>

          <div class="max-w-sm flex-1">
            <div class="h-1.5 overflow-hidden rounded-full bg-muted">
              <span class="block h-full rounded-full bg-brand-studio transition-all"
                [style.width.%]="progressPct()"></span>
            </div>
            <p class="mt-1.5 text-xs text-muted-foreground">Step {{ current() + 1 }} of {{ steps().length }} ·
              {{ essentialsDone() }}/{{ checklist().length }} essentials done</p>
          </div>
        </div>

        <button type="button" class="btn-shout btn-shout-sm btn-shout-primary shrink-0" data-guide-id="monitoring.continue"
          (click)="primary()">
          {{ primaryLabel() }}
        </button>
      </div>
    </div>

  </div>
</div>
